import React, { useState } from "react";
import "./styles.scss"; // Import the SCSS file
import { Icon } from "semantic-ui-react";
import { useIsMobile } from "@/cms/useIsMobile";

interface ExpandableCardProps {
  title: string;
  description: string;
  value?: string | number;
  isDisabled?: boolean;
}

const ExpandableCard: React.FC<ExpandableCardProps> = ({ title, description, value, isDisabled = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = useIsMobile();

  const expandDetails = () => {
    setIsExpanded(true);
  };

  const collapseDetails = () => {
    setIsExpanded(false);
  };

  const toggleDetails = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`expandable-card ${isDisabled ? "disabled" : ""} ${isExpanded ? "expanded" : "collapsed"} ${
        isMobile ? "mobile" : ""
      }`}
      onMouseOver={isMobile ? undefined : expandDetails}
      onMouseLeave={isMobile ? undefined : collapseDetails}
    >
      <div className="card-background" onClick={isMobile ? toggleDetails : undefined}>
        <div className="header-title">{title}</div>
        <div className="value-container">
          {value !== undefined && <span className="value">{value}</span>}
          <div className="toggle-button">
            <Icon name="chevron down" className={isExpanded ? "rotated" : ""} />
          </div>
        </div>
      </div>
      {isExpanded && <div className="description">{description}</div>}
    </div>
  );
};

export default ExpandableCard;
